var moduleMap = {
	"Applications": () => {
		return Promise.all([__webpack_require__.e(5865), __webpack_require__.e(4391), __webpack_require__.e(8730)]).then(() => (() => ((__webpack_require__(39365)))));
	},
	"ApplyNow": () => {
		return Promise.all([__webpack_require__.e(5865), __webpack_require__.e(4391), __webpack_require__.e(9338)]).then(() => (() => ((__webpack_require__(89338)))));
	},
	"PendingApplications": () => {
		return Promise.all([__webpack_require__.e(5865), __webpack_require__.e(4391), __webpack_require__.e(722)]).then(() => (() => ((__webpack_require__(50722)))));
	},
	"Apply": () => {
		return Promise.all([__webpack_require__.e(5865), __webpack_require__.e(1834)]).then(() => (() => ((__webpack_require__(81834)))));
	},
	"ContinueApplication": () => {
		return Promise.all([__webpack_require__.e(5865), __webpack_require__.e(4391), __webpack_require__.e(1899)]).then(() => (() => ((__webpack_require__(61899)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});